import fastclick from 'fastclick'
// import Di18n from '@didi/di18n'
import auth from './auth'

const initFastClick = () => {
  window.addEventListener('load', () => {
    // fastclick.attach(document.body)
    fastclick.prototype.focus = function(targetElement) {
      targetElement.focus()
    }
  })
}

const iosScrollView = () => {
  let blurTime = null
  let scrollTop = window.document.body.scrollTop
  const isAndroid = () => {
    let u = window.navigator.userAgent
    let isAndroidUserAgent = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
    // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    return isAndroidUserAgent
  }
  document.body.addEventListener('focusin', () => {
    if (blurTime) {
      clearTimeout(blurTime, 0)
    }
    if (isAndroid()) {
      event.target.scrollIntoView()
    }
  })
  document.body.addEventListener('focusout', () => {
    blurTime = setTimeout(function () {
      document.body.scrollTop = scrollTop
      window.scrollTo(0, 0)
    }, 500)
  })
}

export default function init() {
  initFastClick()
  iosScrollView()
  return auth.login(true)
}
